module.exports = __webpack_public_path__ + "static/img/weekly.0c0eed4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy_more/weekly.png
// module id = VEDa
// module chunks = 1